import UIComponent from "../component";
import { Offcanvas } from "bootstrap";

export class CustomSelector extends UIComponent {
    init() {
        this.selectOption = this.getSelectOptions();
        this.selectOptions?.hide();

        this.initMobileOffcanvasOptions();

        this.selectSelected?.on("click", this.toggleSelect.bind(this));

        this.selectOption?.forEach((option) => {
            option.addEventListener("click", (e) =>
                this.handleOptionSelect(e, option)
            );
        });

        this.parentDropdown =
            this.element.closest(".dropdown") ||
            this.element.querySelector(".dropdown");
        if (this.parentDropdown) {
            this.parentDropdown.addEventListener("hide.bs.dropdown", () => {
                this.closeOptions();
            });
        }

        this.defaultPlaceholder =
            this.selectedText?.element?.textContent?.trim() || "";
        this.selectedLabel = null;
        const initialText = this.selectedText?.element?.textContent?.trim();
        if (initialText && initialText !== this.defaultPlaceholder) {
            this.selectedLabel = initialText;
        }

        this.bindSearchInput();
    }

    getSelectOptions() {
        return this.findAll("#selectOption");
    }

    initMobileOffcanvasOptions() {
        let offcanvasElement = null;
        if (this.selectSelected) {
            const offcanvasTarget = this.selectSelected.element.getAttribute('data-bs-target');
            if (offcanvasTarget) {
                offcanvasElement = document.querySelector(offcanvasTarget);
            }
        }

        if (!offcanvasElement) {
            offcanvasElement = this.element.querySelector('[data-tbx-name="mobileOffcanvas"]');
        }

        if (offcanvasElement) {
            const closeButton = offcanvasElement.querySelector('.offcanvas-close-btn, [data-bs-dismiss="offcanvas"]');
            if (closeButton) {
                closeButton.addEventListener("click", (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const offcanvasInstance = Offcanvas.getInstance(offcanvasElement) || new Offcanvas(offcanvasElement);
                    offcanvasInstance.hide();
                });
            }

            const mobileOptions = offcanvasElement.querySelectorAll('.language-choice__custom-select__select-option');
            mobileOptions.forEach((option) => {
                option.addEventListener("click", (e) => {
                    if (this.handleMobileOptionSelect) {
                        this.handleMobileOptionSelect(e, option);
                    }
                    const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
                    if (offcanvasInstance) {
                        offcanvasInstance.hide();
                    }
                });
            });
        }
    }

    toggleSelect(e) {
        if (window.innerWidth >= 768) {
            e.preventDefault();
            e.stopPropagation();

            if (!this.selectOptions) return;

            if (this.selectOptions.hasClass("d-none")) {
                this.selectOptions.removeClass("d-none");
            } else {
                this.selectOptions.addClass("d-none");
            }

            if (this.searchInput?.element) {
                if (!this.selectOptions.hasClass("d-none")) {
                    this.openSearch();
                } else {
                    this.resetSearchField();
                }
            }
        }
    }

    closeOptions() {
        if (this.selectOptions && !this.selectOptions.hasClass("d-none")) {
            this.selectOptions.addClass("d-none");
        }
        if (this.searchInput?.element) {
            this.resetSearchField();
        }
    }

    handleOptionSelect(e) {
        e.stopPropagation();
        this.closeOptions();
    }

    handleMobileOptionSelect(e, option) {
        e.stopPropagation();
    }

    setSelectedLabel(text) {
        this.selectedLabel = text;
        if (this.selectedText?.element) {
            this.selectedText.element.textContent = text;
            this.selectedText.element.classList.remove("d-none");
        }
        if (this.searchInput?.element) {
            this.searchInput.element.value = text;
        }
    }

    bindSearchInput() {
        const inputEl = this.searchInput?.element;
        if (!inputEl) return;

        ["click", "mousedown"].forEach((eventName) => {
            inputEl.addEventListener(eventName, (e) => {
                e.stopPropagation();
            });
        });

        inputEl.addEventListener("input", () => {
            this.filterOptions(inputEl.value);
        });
    }

    openSearch() {
        if (!this.searchInput?.element || !this.selectedText?.element) return;

        this.selectedText.element.classList.add("d-none");
        this.searchInput.element.classList.remove("d-none");
        this.searchInput.element.placeholder = this.defaultPlaceholder;
        this.searchInput.element.value = this.selectedLabel || "";
        this.searchInput.element.focus();
        this.searchInput.element.select();
        this.resetFilter();
    }

    resetSearchField() {
        if (!this.searchInput?.element || !this.selectedText?.element) return;

        this.searchInput.element.classList.add("d-none");
        this.selectedText.element.classList.remove("d-none");
        this.searchInput.element.value = "";
        this.resetFilter();
    }

    filterOptions(query) {
        const normalized = query.trim().toLowerCase();
        const options = this.getDesktopOptions();

        if (!options) return;

        options.forEach((option) => {
            const text = option.textContent.trim().toLowerCase();
            if (!normalized || text.includes(normalized)) {
                option.classList.remove("d-none");
            } else {
                option.classList.add("d-none");
            }
        });
    }

    resetFilter() {
        const options = this.getDesktopOptions();

        if (!options) return;

        options.forEach((option) => option.classList.remove("d-none"));
    }

    getDesktopOptions() {
        return this.selectOptions?.el?.()?.querySelectorAll(
            ".language-choice__custom-select__select-option"
        );
    }
}

